import styled from '@emotion/styled';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import mq from '../../../../commons/styles/mediaQueries';

const Wrapper = styled.div`
  height: 100%;
  margin-top: 32px;
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  font-family: ${({ theme }) => theme.fonts.primary};

  ${mq.desktop} {
    padding: 32px 64px;
  }
`;

const DesktopCols = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq.desktop} {
    flex-direction: row;
  }
`;

const PictureColumn = styled.div`
  text-align: center;
  flex-grow: 1;
`;

const Title = styled(Headline3)`
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  ${mq.desktop} {
    text-align: left;
    font-size: ${({ theme }) => theme.sizes['2xl']};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }
`;

const InfoColumn = styled.div`
  max-width: 328px;
`;

const InfoPar = styled.p`
  text-align: center;

  ${mq.desktop} {
    text-align: left;
  }
`;

const BoldText = styled.b`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 36px;
  width: 100%;

  ${mq.desktop} {
    display: flex;
    justify-content: flex-end;
  }
`;

const ConfirmationButton = styled(ButtonPrimaryDark)`
  width: 100%;

  ${mq.desktop} {
    min-width: 193px;
  }
`;

export default {
  Wrapper,
  DesktopCols,
  Title,
  InfoPar,
  InfoColumn,
  PictureColumn,
  BoldText,
  ButtonContainer,
  ConfirmationButton,
};
